<script  lang="ts" setup>
/**
 * UI-kit component
 * Category: Icons
 * Name: 'Icon template'
 * FIGMA: 'https://www.figma.com/design/CFyOwQUjj7uVRQTc03muvG/Demo-CS?node-id=503-222317&m=dev'
 */

defineOptions({
  name: 'IconContainer',
})

withDefaults(defineProps<IconContainerProps>(), {
  is: 'span',
})

interface IconContainerProps {
  is?: 'span' | 'div'
}
</script>

<template>
  <component
    :is="is"
    class="icon-container"
  >
    <slot />
  </component>
</template>

<style scoped lang="scss" src="./IconContainer.scss" />
